import React from 'react'
import { useRouter } from 'next/router'

import { KSDocPrecollection } from 'app/BCKSPage/Invitation/Precollection'
import { useQueryAPIGetKSSelectionCandidate } from 'api/bcks/useAPIBCKSInvitation'
import { SELECTION_STATES_FINAL_PAGE } from 'app/BCKSPage/constants'
import { isToggleEnabled } from 'configs/toggle-feature'
import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'

interface PropsPrecollectionPage {
  isKSSelectionEnabled: boolean
}

export async function getServerSideProps() {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')

  return {
    props: {
      isKSSelectionEnabled,
    },
  }
}

const PrecollectionPage = (props: PropsPrecollectionPage) => {
  const router = useRouter()
  const { data: selectionState } = useQueryAPIGetKSSelectionCandidate()

  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  if (
    SELECTION_STATES_FINAL_PAGE.includes(
      selectionState?.selectionCandidateState
    )
  ) {
    router.replace('/bcks/invitation/final')
  }

  if (selectionState?.selectionCandidateState === 'invitation') {
    router.replace('/bcks/invitation')
  }

  return <KSDocPrecollection />
}

// eslint-disable-next-line react/display-name
PrecollectionPage.Layout = ({ children }) => children

export default PrecollectionPage
